import { OrderPdfStatus } from 'src/entities/order/model/order-status.model';

/** Snapshot de OP en un servicio de programación (scalar + detalle local). */
export interface ServicePurchaseNote {
  purchaseNoteId?: string | null;
  purchaseNoteNumber?: string | number | null;
  purchaseNoteStatus?: string | null;
  reservationStatus?: string | null;
  pdfStatus?: OrderPdfStatus | string | null;
  pdfGeneratedAt?: string | null;
  lastPdfError?: string | null;
  /** Fecha de revisión (no confundir con scheduledPaymentDate de OS). */
  reviewDate?: string | null;
  reservationNumber?: string | null;
  purchaseNoteObservation?: string | null;
  serviceIds?: string[] | null;
  total?: number | null;
}

export function getServicePurchaseNoteId(
  service:
    | {
        purchaseNoteId?: string | null;
        purchaseNote?: ServicePurchaseNote | null;
      }
    | null
    | undefined
): string | null {
  return (
    service?.purchaseNote?.purchaseNoteId ??
    service?.purchaseNoteId ??
    null
  );
}

export function hasPurchaseNote(
  row:
    | {
        purchaseNoteId?: string | null;
        purchaseNote?: ServicePurchaseNote | null;
      }
    | null
    | undefined
): boolean {
  return Boolean(getServicePurchaseNoteId(row));
}

export function isPurchaseNoteStatusConfirmed(
  status: string | null | undefined
): boolean {
  return status?.trim().toUpperCase() === 'CONFIRMADO';
}

export function isPurchaseNoteStatusDeletable(
  status: string | null | undefined
): boolean {
  return isPurchaseNoteStatusConfirmed(status);
}

export function isPurchaseNoteEditable(row: {
  purchaseNoteId?: string | null;
  purchaseNote?: {
    purchaseNoteId?: string | null;
    purchaseNoteStatus?: string | null;
  } | null;
}): boolean {
  return (
    Boolean(getServicePurchaseNoteId(row)) &&
    isPurchaseNoteStatusConfirmed(row?.purchaseNote?.purchaseNoteStatus)
  );
}

export function canDeletePurchaseNote(row: {
  purchaseNoteId?: string | null;
  purchaseNote?: {
    purchaseNoteId?: string | null;
    purchaseNoteStatus?: string | null;
  } | null;
}): boolean {
  return isPurchaseNoteEditable(row);
}

export function getPurchaseNoteMutationBlockedMessage(
  action: 'editar' | 'eliminar',
  status?: string | null
): string {
  const normalized = status?.trim() || 'desconocido';

  if (action === 'eliminar') {
    switch (normalized.toUpperCase()) {
      case 'EN_PROCESO':
        return 'La OP está en proceso y no puede eliminarse desde Operations.';
      case 'PROCESADO':
        return 'La OP ya fue procesada y no puede eliminarse.';
      case 'ELIMINADO':
        return 'Esta Orden de pedido ya fue eliminada.';
      default:
        return `Solo se pueden eliminar órdenes de pedido en estado CONFIRMADO (estado actual: ${normalized}).`;
    }
  }

  return `Solo se puede editar una OP confirmada (estado actual: ${normalized}).`;
}
